import React from "react"
import Tooltip from "@material-ui/core/Tooltip"
import Button from "@material-ui/core/Button"
import Paper from "@material-ui/core/Paper"
import MenuList from "@material-ui/core/MenuList"
import MenuItem from "@material-ui/core/MenuItem"
import { useChargePersonStyle } from "./style"
import { useChargeSelect } from "./hook"
import SubSelectList from "./SubSelectList"
import { Author, GroupAuthor } from "Types/author"
import { getUniqueKey } from "Methods/basic"
import cnchar from "cnchar"
import { useMediaQuery, useTheme } from "@material-ui/core"

export interface ComponentProps {
    chargePerson?: string,
    handleChangeAuthor: (author: { principalId: string, authorId: number}) => void,
    buttonText?: string
}
// 预约负责人选择
export default (props: ComponentProps) => {
    const classes = useChargePersonStyle()
    const {
        open, handleClick,
        chargeName, openIndex, handleChangeOpenIndex,
        handleMenuItemClick,
        authorList,
    } = useChargeSelect(props)
    const { buttonText = "选择负责人" } = props
    const sortFn = (a: any, b: any) => {
        const name = "name"
        if (cnchar.isCnChar(a[name]) && cnchar.isCnChar(b[name])) {
            return cnchar.compareSpell(a[name], b[name]) === "more" ? 1 : -1
        } else if (!cnchar.isCnChar(a[name]) && !cnchar.isCnChar(b[name])) {
            return a[name].localeCompare(b[name])
        } else {
            return -1
        }
    }

    const theme = useTheme()
    const wideScreen = useMediaQuery(theme.breakpoints.up('md'))

    return (
        <div className={classes.root}>
            <Tooltip
                // placement="top"
                placement={wideScreen ? 'top' : 'left'}
                open={open} interactive
                classes={{ tooltip: classes.tooltip }}
                title={(
                    <Paper className={classes.paper}>
                        <MenuList>
                            { authorList.map(({ name, authors }: GroupAuthor, index: number) => (
                                <MenuItem className={classes.menuItem} key={index}>
                                    <SubSelectList
                                        openIndex={openIndex}
                                        index={index + 1}
                                        handleChangeOpenIndex={handleChangeOpenIndex}
                                        text={name}
                                        title={
                                            <Paper className={classes.paper}>
                                                <MenuList>
                                                    {authors.sort((a: any, b: any) => {
                                                        if (cnchar.isCnChar(a.name) && cnchar.isCnChar(b.name)) {
                                                            // 汉字和汉字比
                                                            return cnchar
                                                                .compareSpell(a.name, b.name) === "more" ? 1 : -1
                                                        } else if (cnchar.isCnChar(a.name) || cnchar.isCnChar(b.name)) {
                                                            // 汉字和英文比
                                                            return cnchar.isCnChar(a.name) ? 1 : -1
                                                        } else {
                                                            // 英文和英文比
                                                            return a.name.localeCompare(b.name)
                                                        }
                                                    }).map(({ uid, name, id }: Author) => (
                                                        <MenuItem
                                                            className={classes.subMenuItem}
                                                            key={getUniqueKey()}
                                                            onClick={() => handleMenuItemClick(name, { uid, id }) }>
                                                            {name}
                                                        </MenuItem>
                                                    ))}
                                                </MenuList>
                                            </Paper>
                                        }
                                    />
                                </MenuItem>
                            ))}
                        </MenuList>
                    </Paper>
                )}
            >
                <Button
                    className={classes.button}
                    onClick={handleClick}
                >
                    { chargeName || buttonText }
                </Button>
            </Tooltip>
        </div>
    )
}
